import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Composant Analytics - Tracking des visiteurs
 * 
 * Options disponibles :
 * 1. Plausible Analytics (recommandé) - https://plausible.io
 *    - Respectueux de la vie privée, RGPD compliant
 *    - Dashboard simple et clair
 *    - ~9€/mois, mais données privées
 * 
 * 2. Umami (gratuit, auto-hébergé) - https://umami.is
 *    - Open source, gratuit
 *    - Nécessite un serveur pour héberger
 * 
 * 3. Solution custom
 *    - Backend minimal pour collecter les visites
 *    - Dashboard basique
 */

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Option 1: Plausible Analytics (décommente et remplace par ton domaine)
    // if (window.plausible) {
    //   window.plausible('pageview');
    // }

    // Option 2: Umami (décommente et remplace par ton URL Umami)
    // if (window.umami) {
    //   window.umami.track();
    // }

    // Option 3: Solution custom simple
    // Envoie un événement à ton backend
    trackPageView(location.pathname);
  }, [location]);

  // Fonction pour tracker les pages vues (solution custom)
  const trackPageView = (path) => {
    // Option A: Envoyer à un endpoint backend
    // fetch('https://ton-backend.com/api/track', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({
    //     path,
    //     timestamp: new Date().toISOString(),
    //     referrer: document.referrer,
    //     userAgent: navigator.userAgent,
    //   }),
    // }).catch(() => {}); // Ignore les erreurs silencieusement

    // Option B: Utiliser un service comme LogSnag, PostHog, etc.
    // (exemples à configurer selon le service choisi)
  };

  return null; // Ce composant ne rend rien
};

export default Analytics;



